import { render, staticRenderFns } from "./GraficoMaterialGenetico.vue?vue&type=template&id=71d06017&scoped=true"
import script from "./GraficoMaterialGenetico.vue?vue&type=script&lang=js"
export * from "./GraficoMaterialGenetico.vue?vue&type=script&lang=js"
import style0 from "./GraficoMaterialGenetico.vue?vue&type=style&index=0&id=71d06017&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d06017",
  null
  
)

export default component.exports